import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    ProTableOt,
    Form,
    Badge,
    useProTableOt,
    ExpandableText
} from "../../ui/ot";
import { useArticleManagement } from "../controller/ArticleManagementController";
import ArticleManagementModal from "./ArticleManagementModal";
import { useNavigate } from "react-router-dom";
import useBlogMedia from '../components/use_blog_media'; // 引入自定義 hook


const ArticleTable = ({
    prefixTitle = "",
    showAllColumns = true,
    propsShowColumns,
    mode = "edit",
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const navigate = useNavigate();
    const {
        toLinkSomewhere,
        isMoreContentEmpty,
    } = useBlogMedia([]); // 使用自定義 hook

    const columns = [
        {
            title: "貼文分類",
            key: "blog_category_data",
            dataIndex: "blog_category_data",
            align: "center",
            disabled: true,
            render: (text, record, index) => {
                let finalData = [];
                let blog_category_data =
                    record?.blog_category_data || [];
                blog_category_data.forEach((element) => {
                    let pageNameLanguageData =
                        element?.name_language_data || [];
                    let pageTwName =
                        (pageNameLanguageData || [])?.find(
                            (tmp) =>
                                tmp?.language_culture_code ===
                                "zh-tw"
                        )?.language_culture_value || "-";

                    finalData.push(
                        `${pageTwName}`
                    );
                });
                return (
                    <Row>
                        {finalData.map((ele) => {
                            return <Col>
                                <Badge variant="outline">{ele}</Badge>
                            </Col>;
                        })}
                    </Row>
                );
            }

        },
        {
            title: "標題",
            key: "title",
            dataIndex: "title",
            align: "left",
            // width: '15rem',
        },
        {
            title: "內容",
            key: "content",
            dataIndex: "content",
            align: "left",
            render: (text, record, index) => {
                return (
                    <Row>
                        <Col span={24}>
                            <ExpandableText
                                minHeight={false}
                                text={text}
                                maxLines={2}
                                expandedStyle={"text"}
                            />
                        </Col>
                    </Row>
                )
            }
            // width: '15rem',
        },
        {
            title: "詳細內容",
            key: "more_content",
            dataIndex: "more_content",
            align: "center",
            render: (text, record, index) => {
                if (text && !isMoreContentEmpty(text)) {
                    return (
                        <Row>
                            <Col span={24}>
                                <Button
                                    size={"small"}
                                    type="link"
                                    onClick={e => navigate(`/officialweb/frontend/moreContent/${record.blog_id}`)}
                                >
                                    詳細內容
                                </Button>
                            </Col>
                        </Row>
                    )
                }
                else {
                    return <></>
                }

            }
        },
        {
            title: "內外部連結資訊",
            key: "external_link",
            dataIndex: "external_link",
            align: "left",
            // width: "15rem",
            render: (text, record, index) => {
                if (text) {
                    return (
                        <Row>
                            <Col span={24}>
                                <span
                                    style={{
                                        color: record.extermal_link_check === 0 ? "#6EACDA" : "#FB773C",
                                        fontWeight: "bold"
                                    }}>
                                    {
                                        record.extermal_link_check === 0
                                            ? "內部貼文連結："
                                            : "外部網站連結："
                                    }
                                </span>
                                <Button
                                    type="link"
                                    onClick={() => toLinkSomewhere(record.extermal_link_check, record.external_link)}
                                    style={{
                                        color: "#344C64"
                                    }}
                                >
                                    {
                                        record.extermal_link_check === 0
                                            ? "查看網站頁面"
                                            : "前往外部網站"
                                    }
                                </Button>
                            </Col>
                        </Row>
                    )
                }
                else {
                    return <></>
                }

            }
        },
        // {
        //     title: "已加入頁面",
        //     key: "page",
        //     dataIndex: "page",
        //     align: "left",
        //     width: "15rem",
        // },
        // {
        //     title: '直播室連結',
        //     key: 'blog_room_data',
        //     dataIndex: 'blog_room_data',
        //     align: 'center',
        //     render: ((text, record, index) => {
        //         return text.map((value) => {
        //             return <Button
        //                 type="link"
        //                 onClick={() => {
        //                     navigate(`/officialweb/admin/audio_recorder/liveAdmin/${value?.room_id}`)
        //                 }}
        //             >
        //                 前往
        //             </Button>
        //         })

        //     })
        // },
        {
            title: "貼文點擊次數",
            key: "view_count",
            dataIndex: "view_count",
            align: "center",
        },
        {
            title: "最後編輯時間",
            key: "last_edit_time",
            dataIndex: "last_edit_time",
            align: "center",
        },

        {
            title: "操作",
            valueType: "option",
            key: "option",
            fixed: "right",
            sorter: false,
            disabled: true,

            render: (text, record, _index) => {
                return (
                    <Row gutter={[4, 4]}>
                        <Col>
                            <Button
                                type="link"
                                onClick={() => {
                                    handleEditRow(record);
                                }}
                            >
                                修改
                            </Button>
                        </Col>
                        <Col>
                            <Popconfirm
                                title="刪除項目"
                                description="確定刪除勾選項目?"
                                onConfirm={() => handleDeleteRow(record?.blog_id)}
                                onCancel={() => { }}
                            >
                                <Button type="danger" >
                                    刪除
                                </Button>
                            </Popconfirm>
                        </Col>
                    </Row>
                );
            },
        },
    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['blog_category_data', 'title'])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value.blog_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value.blog_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record.blog_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record.blog_id);
                selectRow = selectRow.filter((row) => row.blog_id !== record.blog_id);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get");
    const onCleanSelected = () => {
        setSelectedRowKeys([]);
        setSelectedRowsInfo([]);
    };
    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();
        form.setValue('blog_type_classify_structure_type_blog_data', []);
        form.setValue('blog_news_data', []);

    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);

        form.resetFields();
        let editRecord = { ...record }
        editRecord = {
            ...editRecord,
            blog_category_data: editRecord?.blog_category_data.map((value) => {
                return value?.category_id
            })
        }
        if (editRecord) {
            Object.keys(editRecord).forEach((key) => {
                if (key === "extermal_link_check") {
                    if (editRecord['extermal_link_check'] === 1) {
                        form.setValue(key, editRecord[key]);
                        form.setValue('extermal_link_check_replace', true);
                    }
                    else {
                        form.setValue('extermal_link_check_replace', false);
                    }
                }
                else {
                    form.setValue(key, editRecord[key]);

                }
            });
        }

    };
    const handleDeleteRow = (id) => {
        let data = [];
        if (id) {
            data = [
                {
                    blog_id: id,
                },
            ];
        } else {
            data = selectedRowsInfo.map((val) => {
                return {
                    blog_id: val?.blog_id,
                };
            });
        }
        if (data.length > 0) {
            deleteArticleManagement(data);
        } else {
            message.info("請選擇項目");
        }
    };

    const onFormFinish = (values) => {
        let finalData = { ...values }
        let blog_category_data = (values?.blog_category_data).map((blogCategoryData) => {
            return {
                blog_category_id: blogCategoryData
            }
        })
        finalData = {
            ...finalData,
            blog_category_data
        }
        if (axiosMode === "post") {
            postArticleManagement([finalData]);
        } else if (axiosMode === "patch") {
            patchArticleManagement([finalData]);
        }
    };
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const setParamsFilter = (obj) => {
        //拿掉值為空或是null 的東西
        return Object.entries(obj).reduce(
            (all, [key, value]) =>
                value === "" ? { ...all } : { ...all, [key]: value },
            {}
        );
    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });

    const {
        getArticleManagement,
        postArticleManagement,
        patchArticleManagement,
        deleteArticleManagement,
        // patchAppointmentclick
    } = useArticleManagement({
        onFinish,
        onBefore,
    });

    useEffect(() => {
        checkAll();
        document.title = `${prefixTitle} | 貼文管理`;
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>
        <Col>
            <ArticleManagementModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                propsForm={form}
                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}
                onFinish={onFormFinish}
            />
        </Col>
        <Col span={24}>
            <ProTableOt
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={"blog_id"}
                selections={
                    {
                        // onChange: (index_, data_) => set_data(data_)
                    }
                }
                toolBarRender={() => {
                    if (mode === "edit") {
                        return [
                            <Button
                                size="sm"
                                onClick={() => {
                                    navigate('/officialweb/admin/blogCategoryManagement')
                                }} >
                                新增貼文分類
                            </Button>,
                            <Button
                                size="sm"
                                onClick={() => {
                                    handleAddRow()
                                }} >
                                新增貼文
                            </Button>,
                            <Popconfirm
                                title="刪除貼文"
                                description="確定刪除勾選的貼文?"
                                onConfirm={() => handleDeleteRow()}
                                onCancel={() => { }}
                            >
                                <Button
                                    type="primary"
                                    style={{
                                        color: "#000",
                                        backgroundColor: "#ffedee",
                                    }}
                                >
                                    刪除貼文
                                </Button>
                            </Popconfirm>,
                        ]
                    }
                    else {
                        return []
                    }
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get");
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return getArticleManagement(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }
                }
                scroll={{
                    x: "100%",
                }}
            />
        </Col>
    </Row>)

}
const ArticleManagement = () => {

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Typography.Title
                    level={3}
                >
                    貼文管理
                </Typography.Title>
                <ArticleTable />
            </Col>
        </Row>
    );
};
export { ArticleTable }
export default ArticleManagement;
